export default "__VITE_ASSET__Dx4wTxbv__"